import React, { ReactNode } from 'react';
import { VilkaarTekst } from './SamtykkeReducer';
import './Vilkaar.scss';

interface VilkaarTextProps {
  vilkaar: VilkaarTekst;
}
export default function VilkaarText({ vilkaar }: Readonly<VilkaarTextProps>): ReactNode {
  return (
    <div
      className="vilkaar-page text-black"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: vilkaar.fullTekst,
      }}
    />
  );
}
